import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

export const Error: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 151" width="150" height="151">
      <path fill="#EAECF0" d="M75 150.65c41.421 0 75-33.578 75-75 0-41.421-33.579-75-75-75s-75 33.58-75 75c0 41.422 33.579 75 75 75Z" />
      <mask
        id="b"
        width={150}
        height={151}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="url(#a)" d="M75 150.65c41.421 0 75-33.578 75-75 0-41.421-33.579-75-75-75s-75 33.58-75 75c0 41.422 33.579 75 75 75Z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#4D5A79"
          d="M78.158 114.514v48.161c0 8.338-6.763 15.098-15.106 15.098H-9.895c-6.202 0-11.23 5.025-11.23 11.224v31.066c0 1.07-.867 1.936-1.938 1.936A1.936 1.936 0 0 1-25 220.063v-31.066c0-8.338 6.763-15.097 15.105-15.097h72.949c6.201 0 11.228-5.024 11.228-11.223v-48.163h3.877Z"
        />
        <path
          fill="#66758D"
          d="M82.518 124.909v7.718a3.337 3.337 0 0 1-3.338 3.336h-5.92a3.329 3.329 0 0 1-2.54-1.172 3.323 3.323 0 0 1-.799-2.164v-7.718h12.597Z"
        />
        <path fill="#98A2B3" d="M89.098 106.918v15.416a4.313 4.313 0 0 1-4.314 4.312H67.656a4.313 4.313 0 0 1-4.313-4.312v-15.416h25.755Z" />
        <path
          fill="#98A2B3"
          d="M61.808 106.919h28.823a.566.566 0 0 0 .566-.566v-2.263a.566.566 0 0 0-.566-.566H61.808a.566.566 0 0 0-.566.566v2.263c0 .313.254.566.566.566Z"
        />
        <path
          fill="#3C4960"
          d="M72.355 103.523h-4.39V93.031a2.194 2.194 0 0 1 4.389 0v10.492Zm9.925-12.685c1.212 0 2.195.983 2.195 2.193v10.492h-4.39V93.031c0-1.211.984-2.193 2.194-2.193h.001Z"
        />
        <path
          fill="#66758D"
          d="M89.098 106.918H63.343v1.243h25.755v-1.243Zm0 6.516v8.9a4.312 4.312 0 0 1-4.314 4.311H72.76c12.142 0 16.338-13.211 16.338-13.211Z"
        />
        <path fill="#3C4960" d="M82.518 126.646H69.923v.805h12.595v-.805Z" />
        <path fill="#15172D" d="M72.356 101.988h-4.39v1.535h4.39v-1.535Zm12.119 0h-4.39v1.535h4.39v-1.535Z" />
        <path
          fill="#3C4960"
          d="M82.518 126.645v5.982a3.337 3.337 0 0 1-3.338 3.336h-5.92a3.33 3.33 0 0 1-2.54-1.172c9.227 1.13 10.636-8.147 10.636-8.147h1.162v.001Z"
        />
        <path
          fill="#4D5A79"
          d="M194-24.064c0 1.07-.868 1.938-1.938 1.938H89.389c-6.202 0-11.23 5.026-11.23 11.224v50.896h-3.876v-50.896C74.283-19.24 81.045-26 89.389-26h102.673c1.07 0 1.938.868 1.938 1.936Z"
        />
        <path
          fill="#66758D"
          d="M82.518 35.635v-7.718a3.337 3.337 0 0 0-3.338-3.336h-5.92a3.33 3.33 0 0 0-2.54 1.172 3.326 3.326 0 0 0-.799 2.164v7.718h12.597Z"
        />
        <path fill="#98A2B3" d="M89.098 53.627V38.211a4.313 4.313 0 0 0-4.314-4.311H67.656a4.312 4.312 0 0 0-4.313 4.31v15.417h25.755Z" />
        <path
          fill="#98A2B3"
          d="M61.808 57.02h28.823a.566.566 0 0 0 .566-.565v-2.263a.566.566 0 0 0-.566-.566H61.808a.566.566 0 0 0-.566.566v2.263c0 .312.254.566.566.566Z"
        />
        <path
          fill="#66758D"
          d="M89.098 52.384H63.343v1.243h25.755v-1.243Zm0-5.273v-8.9a4.313 4.313 0 0 0-4.314-4.311H72.76c12.142 0 16.338 13.211 16.338 13.211Z"
        />
        <path fill="#3C4960" d="M82.518 33.094H69.923v.806h12.595v-.806Z" />
        <path
          fill="#3C4960"
          d="M82.518 33.898v-5.98a3.337 3.337 0 0 0-3.338-3.337h-5.92a3.33 3.33 0 0 0-2.54 1.172c9.227-1.13 10.636 8.147 10.636 8.147h1.162v-.002Z"
        />
        <path
          fill="#98A2B3"
          d="M42.438 70.483h-7.975a1.097 1.097 0 1 1 0-2.194h7.975a1.097 1.097 0 1 1 0 2.194ZM52.56 60.367a1.097 1.097 0 0 1-1.098-1.097v-7.971a1.097 1.097 0 1 1 2.195 0v7.97c0 .607-.49 1.098-1.097 1.098Zm-7.318 2.803c-.28 0-.561-.108-.777-.321l-5.477-5.475a1.097 1.097 0 0 1 1.552-1.551l5.477 5.474a1.095 1.095 0 0 1-.776 1.873Zm64.76 31.998h7.975a1.097 1.097 0 1 1 0 2.195h-7.975a1.097 1.097 0 1 1 0-2.195Zm-10.121 10.115c.607 0 1.098.491 1.098 1.098v7.97a1.097 1.097 0 1 1-2.195 0v-7.97c0-.607.49-1.098 1.097-1.098Zm7.318-2.801c.28 0 .561.107.776.321l5.478 5.475a1.097 1.097 0 0 1-1.552 1.551l-5.478-5.475a1.096 1.096 0 0 1 .777-1.872h-.001Z"
        />
      </g>
      <defs>
        <linearGradient id="a" x1={75} x2={75} y1={0.65} y2={150.65} gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3ECFA" />
          <stop offset={1} stopColor="#DAE7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Error;
